import { render, staticRenderFns } from "./YAxisExtSelector.vue?vue&type=template&id=067da459&scoped=true&"
import script from "./YAxisExtSelector.vue?vue&type=script&lang=js&"
export * from "./YAxisExtSelector.vue?vue&type=script&lang=js&"
import style0 from "./YAxisExtSelector.vue?vue&type=style&index=0&id=067da459&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067da459",
  null
  
)

export default component.exports